<template>
  <el-container id="aUser">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <span style="margin-left:0vw;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_status" ref='select2' @change="getUser()"
                       @visible-change='show_change2'
                       clearable filterable placeholder="全部状态"
                       style="width:15vw;">
              <el-option
                  v-for="item in li_status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </span>
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
                placeholder="输入号码查询"
                style="width:15vw;"
                prefix-icon="el-icon-search"
                clearable
                @change="getUser()"
                v-model="edi_phone">
            </el-input>
          </span>
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
                placeholder="输入名称查询"
                style="width:15vw;"
                prefix-icon="el-icon-search"
                clearable
                @change="getUser()"
                v-model="edi_name">
            </el-input>
          </span>
          <el-button style="margin-left:10px;height:40px;" type="primary" @click="onResh" icon="el-icon-refresh">
            重置
          </el-button>
          <!--          <el-button @click="addUser" size="small" type="primary" icon="el-icon-plus"-->
          <!--                     style="margin-left:auto;margin-right:15px">-->
          <!--            新增人员-->
          <!--          </el-button>-->
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
          </div>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small"
                         @click="roveUser(scope.row,true)"
                         style="color:#4B5563;font-size: 14px">查看
              </el-button>
              <!--              <el-button v-if="scope.row.state!=='已发布'"-->
              <!--                         @click="change_user(scope.row,'w')" type="text" size="small"-->
              <!--                         style="color:#1677FF;font-size: 14px">编辑-->
              <!--              </el-button>-->
              <el-button
                  v-if="scope.row.userState!=='已认证'&&scope.row.userState!=='游客'"
                  @click="roveUser(scope.row,false)" type="text" size="small"
                  style="color:#22C55E;font-size: 14px">审核
              </el-button>
              <el-button v-if="scope.row.userState==='已认证'&&scope.row.userState!=='游客'"
                         @click="del_user(scope.row,false)" type="text" size="small"
                         style="color:red;font-size: 14px">冻结
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10,20,30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="35vw" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiApp'> <!--v-draggable 拖动-->
      <div
          style="display:flex;margin-bottom:10px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <el-descriptions class="margin-top" title="认证信息" :column="3" :colon="false" direction="horizontal">
          <el-descriptions-item label="房主姓名:">{{ showInfo.name }}</el-descriptions-item>
          <el-descriptions-item :span="2" label="房主电话:">{{ showInfo.applyNumber }}</el-descriptions-item>
          <el-descriptions-item label="楼栋:">{{ showInfo.buildingInfo }}</el-descriptions-item>
          <el-descriptions-item label="单元:">{{ showInfo.unitNum }}</el-descriptions-item>
          <el-descriptions-item label="房号:">{{ showInfo.houseNum }}</el-descriptions-item>
          <el-descriptions-item :span="3" label="家人电话:">{{ showInfo.otherPhoneNumber }}</el-descriptions-item>
          <el-descriptions-item :span="4" label="详细地址:">{{ showInfo.detail }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin-top:0px;padding-left:0;">
        <p style="margin:0">审核意见</p>
        <textarea maxlength="30" :disabled="this.ischeck" v-model="showInfo.comments"
                  style="width:98%;height:10vh"></textarea>
      </div>
      <div v-if="!this.ischeck" style="display:flex">
        <el-button style="margin-left: auto" @click="daiApp=false">
          返回
        </el-button>
        <el-button type="danger" style="margin-left:10px" @click="changState(showInfo,false)">
          拒绝认证
        </el-button>
        <el-button type="primary" style="margin-left:10px;margin-right:10px" @click="changState(showInfo,true)">
          通过认证
        </el-button>
      </div>
      <div v-else style="display:flex;width:100%">
        <el-button type="primary" @click="daiApp=false" style="margin-left:auto;margin-right:5px">返回</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="冻结提示"
        :visible.sync="daiDelUser"
        width="30%">
      <span>确定冻结该人员吗？冻结后需要重新审核,请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelUser = false">取 消</el-button>
        <el-button type="primary" @click=delUser()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"aUser",
  data() {
    return {
      h_text:"用户管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      edi_auth:[],
      li_auth:[], /*角色列表*/
      li_user:[],
      edi_phone:"",
      edi_name:"",
      ischeck:false,
      page:1,
      pageSize:10,
      total:0,
      autPage:1,
      autPageSize:10,
      autTotal:10,
      accNo:-1,
      maxHeight:window.innerHeight - 225,
      defHead:[
        //{'key':"序号",'val':"item","w":"200px"},
        {'key':"用户ID",'val':"accNo","w":"auto"},
        {'key':"用户名",'val':"name","w":"auto"},
        {'key':"电话",'val':"applyNumber","w":"auto"},
        {'key':"注册时间",'val':"registerTime","w":"auto"},
        // {'key':"用户类型",'val':"authName","w":"auto"},
        {'key':"认证状态",'val':"userState","w":"auto"}
      ],
      tabData:[],
      titles:"认证详情",
      daiApp:false,
      showInfo:{},
      edi_status:"",
      li_status:[
        {value:1,label:'游客'},
        {value:2,label:'审核中'},
        {value:3,label:'已认证'},
        {value:4,label:'认证失败'},
        {value:5,label:'冻结中'}
      ],
      edi_wx:"",
      li_wx:[
        {value:'是',label:'是'},
        {value:'否',label:'否'}
      ],
      post_head:{},
      daiDelUser:false
    };
  },
  methods:{ /*方法存放*/
    onResh() {
      this.edi_status = "";
      this.edi_name = "";
      this.edi_phone = "";
      this.getUser();
    },
    change_user(row,operate) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsUserGlSon',
        query:{
          key:'changeUser',
          accNo:row.accNo,
          operate:row.operate
        }
      });
    },
    addUser() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/glUserSon',
        query:{key:'addUser'}
      });
    },
    roveUser(row,ischeck) { /*审核用户*/
      this.ischeck = ischeck;
      this.showInfo = {
        "accNo":row.accNo,
        "name":row.name,
        "applyNumber":row.applyNumber,
        "buildingInfo":row.buildingInfo,
        "unitNum":row.unitNum,
        "houseNum":row.houseNum,
        "comments":row.comments,
        "otherPhoneNumber":row.otherPhoneNumber,
        "detail":row.detail
      };
      this.daiApp = true;
    },
    del_user(row) {
      this.accNo = row.accNo;
      this.daiDelUser = true;
    },
    delUser() {
      const params = {
        'accNo':this.accNo,
        'userStateId':5,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.approveUser,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("冻结成功");
        this.daiDelUser = false;
        this.getUser();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("冻结失败");
        }
      });
    },
    changState(row,re_d) {
      const params = {
        'accNo':row.accNo,
        'comments':row.comments,
        'projectId':localStorage.getItem("projectId")
      };
      if (re_d) {
        params["userStateId"] = 3;
      } else {
        params["userStateId"] = 4;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.approveUser,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("审核成功");
        this.daiApp = false;
        this.getUser();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("审核失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getUser();
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    init_View() {
      let data = this.li_user;
      let li_d = [];
      let j = 1;
      let l = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          id:data[i]['id'],
          name:data[i]['name'], /*用户名*/
          nickName:data[i]['nickName'], /*用户名*/
          applyNumber:data[i]['applyNumber'], /*电话*/
          accNo:data[i]['accNo'], /*用户ID*/
          authName:data[i]['nickName'],  /*角色id*/
          buildingInfo:data[i]['buildingInfo'],  /*楼栋*/
          unitNum:data[i]['unitNum'],  /*单元*/
          houseNum:data[i]['houseNum'],  /*门牌号*/
          detail:data[i]['detail'],  /*详细地址*/
          otherPhoneNumber:data[i]['otherPhoneNumber'],  /*家人电话*/
          comments:data[i]['comments'],  /*详细地址*/
          userState:"",  /*用户状态*/
          registerTime:data[i]['registerTime'],  /*注册时间*/
          userStateId:data[i]['userStateId']  /*状态id*/
          // beginExpDate:data[i]['beginExpDate']  /*注册时间*/
        };
        if (data[i]['phoneNumber']) {
          d["applyNumber"] = data[i]['phoneNumber'];
        } else if (data[i]['applyNumber']) {
          d["applyNumber"] = data[i]['applyNumber'];
        } else {
          d['applyNumber'] = data[i]["otherPhoneNumber"];
        }
        d['name'] = "";
        if (data[i]['name']) {
          d['name'] = data[i]["name"];
        } else if (data[i]['userName']) {
          d['name'] = data[i]["userName"];
        } else if (data[i]['nickName']) {
          d['name'] = data[i]["nickName"];
        }
        let ds = this.li_status.find(item => item.value === d.userStateId);
        if (ds) {
          d["userState"] = ds["label"];
        }
        li_d.push(d);
        j += 1;
      }
      // this.li_auth = l
      this.tabData = li_d;
    },
    getAuthority() {
      if (this.autPage * this.autPageSize > this.autTotal) {
        return;
      }
      const params = {
        'page':this.autPage,
        'pageSize':this.autPageSize
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAuthorityList,params,headers).then(res => {
        console.log(res.data.data);
        this.autTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_auth;
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['authorityId'],
            label:data[i]['authorityName']
          };
          l.push(d);
        }
        this.li_auth = l;
        this.autPage += 1;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取角色信息失败");
        }
      });
    },
    getUser() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.edi_status) {
        params["userStateId"] = this.edi_status; /*状态id筛选*/
      }
      if (this.edi_phone) {
        params["applyNumber"] = this.edi_phone; /*电话筛选*/
      }
      if (this.edi_name) {
        params["name"] = this.edi_name; /*名称筛选*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getHsUserList,params,headers).then(res => {
        console.log("getUser:",res.data.data["list"]);
        this.li_user = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取用户信息失败");
        }
      });
    },
    scolling() { /*下拉更新*/
      let e = this.$refs.select1.$refs.scrollbar.$refs.wrap;
      if (this.loading) return; /*loading为真跳过-防止误触*/
      let loadMore = e.scrollHeight - e.scrollTop <= e.clientHeight;
      if (loadMore) { /*到底时触发 loadMore*/
        this.loadMore();
      }
    },
    loadMore() {
      this.loading = true; // 设置加载状态为 true，防止重复请求
      this.getAuthority();
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    //this.$refs.select1.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
    this.getUser();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        // if (this.edi_auth && item.authorityId !== this.edi_auth) {
        //   this.state = false
        // }
        // if (this.edi_name && !item.userName.includes(this.edi_name)) {
        //   this.state = false
        // }
        // if (this.edi_status) {
        //   if (this.edi_status.includes("启用")) {
        //     if (!item.userState) {
        //       this.state = false
        //     }
        //   } else {
        //     if (item.userState) {
        //       this.state = false
        //     }
        //   }
        // }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#aUser {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.dialogApp {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    text-align: left;
    background: linear-gradient(to right, #6366F1, #10B981);
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/hs/UserGl.vue